import React from 'react';
import { EVENT_FEED_TYPES } from './EventFeedWidget.jsx';
import { useSelector } from 'react-redux';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import CollapsibleSection from '../../../common/CollapsibleSection.jsx';
import CommonField from '../../settings_sidebar/ag_chart/components/CommonField.jsx';
import WidgetTitleSettings from '../../settings_sidebar/WidgetTitleSettings.jsx';

function EventFeedWidgetSettings({ widgetId }) {
    const setAttribute = useSetWidgetAttribute(widgetId);
    const settings = useSelector(state => state.dashboard.widgets[widgetId].settings);
    const {available_filters = []} = settings;

    const handleCheckboxChange = (event) => {
      const {value, checked} = event.target;

      if (checked) {
        if (!available_filters.includes(value)) {
          setAttribute('settings.available_filters', [...available_filters, value])
        }
      } else {
        setAttribute('settings.available_filters', available_filters.filter(v => v !== value))
        setAttribute(`settings.${value}`, false)
      }
    };

    return (<>
      <hr />
      <CollapsibleSection title={I18n.t('content_settings')}>
        <WidgetTitleSettings widgetId={widgetId} />

        <CommonField label={I18n.t('available_filters')}>
          <div>
            {EVENT_FEED_TYPES.map((availableFilter) => (
              <div key={availableFilter}>
                <input
                  type="checkbox"
                  id={availableFilter}
                  name={availableFilter}
                  value={availableFilter}
                  checked={available_filters.includes(availableFilter)}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor={availableFilter} className="radio-inline-label">
                  {I18n.t(availableFilter == 'support' ? availableFilter : `${availableFilter}s`) }
                </label>
              </div>
            ))}
          </div>
        </CommonField>

        {available_filters.length > 0 &&
          <CommonField label={I18n.t('choose_which_filters_to_select_by_default')}>
            <div>
              {available_filters.map((type) => (
                <div key={`select-${type}`} >
                  <input
                    type="checkbox"
                    id={`select-${type}`}
                    name={type}
                    checked={settings[type]}
                    onChange={(e) => setAttribute(`settings.${type}`, e.target.checked)}
                  />
                  <label htmlFor={`select-${type}`} className="radio-inline-label">
                    { I18n.t(type == 'support' ? type : `${type}s`) }
                  </label>
                </div>
              ))}
            </div>
          </CommonField>
        }
      </CollapsibleSection>
    </>);
}

export default EventFeedWidgetSettings;
